import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../i18n';
import { COOKIE_CONSENT_KEY } from '../config';
import LanguageSwitcher from './LanguageSwitcher';

export default function CookieBanner() {
  const { t } = useLanguage();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(COOKIE_CONSENT_KEY)) setVisible(true);
  }, []);

  if (!visible) return null;

  const accept = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'accepted');
    setVisible(false);
  };
  const decline = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'declined');
    setVisible(false);
  };

  return (
    <div className="cookie-banner" role="dialog" aria-live="polite" aria-label={t('cookieBanner', 'ariaLabel')}>
      <p className="cookie-banner-text">
        {t('cookieBanner', 'message')}{' '}
        <Link to="/cookie-policy" className="cookie-banner-link">
          {t('cookiePolicyLink')}
        </Link>
        .
      </p>
      <div className="cookie-banner-actions">
        <LanguageSwitcher />
        <button className="cookie-banner-btn cookie-banner-accept" onClick={accept}>
          {t('cookieBanner', 'accept')}
        </button>
        <button className="cookie-banner-btn cookie-banner-decline" onClick={decline}>
          {t('cookieBanner', 'decline')}
        </button>
      </div>
    </div>
  );
}
